import icon from './media/icon.svg';
import disabledIcon from './media/disabledIcon.svg';
import { sectionType, DEFAULT_LINK, ALL_SITE_TYPES, DOCS_BASE_URL } from 'constants';
import THEME from './theme.jsx';

const NAME = 'video-list'; /* component internal name */
const VERBOSE_NAME = 'video list'; /* component displayed name */

export const BENTOMATIC_FIELDS = {
    title: 'data.title',
    CTAText: 'text'
};

export const DEFAULT_CTA = {
    text: '',
    textPlaceholder: 'Call To Action',
    link: { ...DEFAULT_LINK }
};

export const VIDEO_TYPES = {
    ALL: '',
    CLIP: 'clip',
    PREVIEW: 'preview',
    EPISODE: 'full_length',
    SPECIAL: 'special'
};

export const ITEMS_PER_PAGE = {
    min: 4,
    max: 8
};

export const PAGINATION_TYPES = {
    LOAD_MORE: 'LOAD_MORE',
    PAGINATION: 'PAGINATION',
    CAROUSEL: 'CAROUSEL'
};

export const CAROUSEL_ITEMS_PER_PAGE = 24;
export const CAROUSEL_PAGINATION_LIMIT = 20;

export const ORDER = [
    {
        value: '-premiered_on',
        title: 'By Descending Order'
    },
    {
        value: 'premiered_on',
        title: 'By Ascending Order'
    }
];

/* component visible data */
const DATA = {
    cta: {},
    title: '',
    titlePlaceholder: 'Video List Title'
};

/* component settings */
const SETTINGS = {
    selectedShows: [],
    itemsPerPage: ITEMS_PER_PAGE.min,
    displayVideoListTitle: true,
    displayVideoTitle: true,
    displayShowTitle: true,
    displayVideoDescription: true,
    displayVideoMeta: true,
    displayCTA: false,
    displayShowCTA: false,
    includePassportVideos: true,
    videoType: VIDEO_TYPES.ALL,
    paginationType: PAGINATION_TYPES.CAROUSEL,
    order: ORDER[0],
    player: {
        autoplay: false,
        topbar: false
    },
    selectedRegions: [{ value: 'US', label: 'US' }]
};

const RESTRICTION = {
    allowedSections: new Set([sectionType.CONTENT]),
    allowedColumns: new Set([12, 8]),
    allowedSiteTypes: ALL_SITE_TYPES
};

const METADATA = {
    name: NAME,
    verboseName: VERBOSE_NAME,
    icon,
    disabledIcon,
    data: DATA,
    settings: SETTINGS,
    restriction: RESTRICTION,
    theme: THEME
};

export const DOCUMENTATION_LINK = DOCS_BASE_URL + 'B3/4751549/Video+List';

export default METADATA;
